import axios from 'axios';
import { trackEvent } from "../analytics";

import { IFeedEntry } from "./FeedEntry";

const DEFAULT_FEED = "art";
const HOSTNAME = process.env.REACT_APP_LRNER_API_URL || "http://localhost:4000";
console.log(
  `Setting hostname to: ${HOSTNAME} because REACT_APP_LRNER_API_URL is ${process.env.REACT_APP_LRNER_API_URL}`
);

console.log(HOSTNAME);

const GLOBAL_FEED_URL = `${HOSTNAME}/global_feeds`;
const INTEGRATION_ENTRIES_URL = `${HOSTNAME}/integration_entries`;


export default class GlobalFeed {
  _globalFeed: any;
  _creator?: string;
  _feed?: string;
  _tag?: string;

  creator(_creator: string) {
    this._creator = _creator;
    return this;
  }

  tag(_tag: string) {
    this._tag = _tag;
    return this;
  }

  feed(_feed: string) {
    this._feed = _feed;
    return this;
  }

  async track() {
    if (this._tag) trackEvent(`Selected Tag: ${this._tag}`);
    return this;
  }

  url() {
    if (this._tag && this._tag !== "default") {
      return `${GLOBAL_FEED_URL}?tag=${this._tag}`;
    }
    if (this._creator && this._creator !== "default") {
      return `${INTEGRATION_ENTRIES_URL}?creator=${this._creator}`;
    }
    if (this._feed || this._feed === DEFAULT_FEED) {
      return `${GLOBAL_FEED_URL}?feed=${this._feed}`;
    }
    return GLOBAL_FEED_URL;
  }

  async get() {
    this._globalFeed = await axios.get(this.url());
    return this;
  }

  filter(feedKey: string, feeds: any) {
    if (!feeds[feedKey]) {
      feeds[feedKey] = [];
    }

    console.log(this._globalFeed);
    let filteredGlobalFeed = this._globalFeed.data.data.filter(
      (feedEntry: IFeedEntry) => {
        return !feeds[feedKey]
          .map((existingFeedEntry: IFeedEntry) => {
            return existingFeedEntry.id;
          })
          .includes(feedEntry.id);
      }
    );

    return filteredGlobalFeed;
  }

  async fetch(creatorInput: string, tagInput: string, feeds: any) {
    return this.tag(tagInput)
      .creator(creatorInput)
      .track()
      .then(() => this.get())
      .then(() => this.filter(tagInput, feeds));
  }
}
